let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bxn2E")).then(() => parcelRequire('cjNTd'));